import { ThankYouPage } from './thank-you.component';
import { connect } from 'react-redux';
import { fetchOrder } from "./../../api/order/orderAction";

const mapDispatchToProps = {
    fetchOrder
};

const mapStateToProps = state => ({
    isLoading: state.orderPage.isLoading,
    order: state.orderPage.completedOrder
});

export const ThankYouContainer = connect(mapStateToProps, mapDispatchToProps)(ThankYouPage);